import React from 'react';

const GenericIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"{...props}>
    <circle fill="none" stroke="currentColor" strokeWidth="2" cx="12" cy="12" r="11.077"/>
  </svg>
);

export default GenericIcon;
